import {
  isBefore,
  parseISO,
  format,
  isEqual,
  differenceInWeeks,
} from "date-fns"

export const combineDateAndTime = (inputDate, inputTime) => {
  if (typeof inputDate !== "undefined") {
    const formattedDate = format(inputDate, "yyyy-MM-dd")
    let combinedResult = formattedDate
    if (inputDate && inputTime) {
      combinedResult = combinedResult + "T" + inputTime + ":00"
      return combinedResult
    } else {
      combinedResult = combinedResult + "T00:00:00"
      return combinedResult
    }
  }
}

export const notFutureDatime = (inputDate, inputTime) => {
  if (inputDate && inputTime) {
    let formattedDateTime = parseISO(combineDateAndTime(inputDate, inputTime))
    return isBefore(formattedDateTime, new Date())
  }
}

export const notWeeksEarlier = (inputDate, weeksEarlier) => {
  if (inputDate && weeksEarlier) {
    let weekDifference = differenceInWeeks(new Date(), inputDate)
    return weekDifference >= weeksEarlier
  }
}

export const convertStringToDecimal = amount => {
  if (amount) {
    return parseFloat(amount.toString().replace(/,/g, ""))
  }
}

export const isAfterDateTime = (startDate, startTime, endDate, endTime) => {
  if (startDate && startTime && endDate && endTime) {
    if (
      startDate &&
      startTime.length === 5 &&
      endDate &&
      endTime.length === 5
    ) {
      let startDateTime = parseISO(combineDateAndTime(startDate, startTime))
      let endDateTime = parseISO(combineDateAndTime(endDate, endTime))

      return (
        isBefore(startDateTime, endDateTime) ||
        isEqual(startDateTime, endDateTime)
      )
    }
  } else {
    return true
  }
}

export const decimalToString = maxAmount => {
  if (maxAmount) {
    // return maxAmount.toLocaleString()
    return maxAmount > 0
      ? maxAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      : "0"
  } else {
    return maxAmount
  }
}

export const checkBenefitChosened = (chosenedBenefits, coverageCode) => {
  let indexOfBenefits = chosenedBenefits
    .map(function(e) {
      return e.CoverageCode
    })
    .indexOf(coverageCode)

  return indexOfBenefits !== -1 ? true : false
}

export const dateFormat = val => {
  let date = limit(val.substring(0, 2))
  let month = limit(val.substring(2, 4))
  let year = yearLimit(val.substring(4, 8))

  return date + (month.length ? "/" + month : "") + "/" + year
}
const limit = (val, max) => {
  if (val.length === 2) {
    //this can happen when user paste number
    if (val > max) {
      val = max
    } else if (Number(val) === 0) {
      val = "01"
    }
  }
  return val
}
const yearLimit = val => {
  const minYear = 1900
  const maxYear = 2099

  if (val.length === 4) {
    //this can happen when user paste number
    if (val > maxYear) {
      val = maxYear
    } else if (val < minYear) {
      val = minYear
    }
  }
  return val
}
